// 判断字符串内容是否为空
export function isEmptyOrNullOrUndefined(str?: string | undefined | null): boolean {
    if (str === undefined || str === null || str === "undefined" || str === "null") {
        return true;
    }

    // 如果值不是 undefined 或 null，再继续判断是否是空字符串或只包含空白字符
    return str.trim() === '';
}